export enum PaymentRouterProviderEnum {
  SUNFLOWER = 'sunflower',
  PAY_COM = 'pay_com',
}
